// import {
//   IExample,
//   IExampleBody,
//   PSReqDTO,
//   PSFReqDTO,
//   PSFResDTO,
//   IDokumenty,
// } from "types/types";

import useRequest from "./useRequest";

export function useDokumentyAPI(data) {
  // return useRequest<PSFResDTO<IRejstrikDobrovolnychSvazkuObci>>({
  return useRequest({
    url: `o/dokumenty-rest/list`,
    method: "POST",
    data,
  });
}

export function useSitesAPI() {
  return useRequest(
    {
      url: `o/dokumenty-rest/sites`,
      method: "GET",
    },
    {
      // note: get data using mutate() function, it will not work onLoad()
      revalidateOnMount: false,
    }
  );
}

export function useFoldersAPI(groupId) {
  return useRequest({
    url: `o/dokumenty-rest/folders`,
    params: { groupId },
    method: "GET",
  });
}
